import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { brokerCasesApi } from '@api/brokerCases/brokerCasesApi';
import type { CaseSearchParams, CaseSearchResponse } from '@api/brokerCases/types';
export const BROKER_CASES_SEARCH_QUERY_KEY = 'broker-cases-search';

interface UseBrokerCasesSearchOptions {
  enabled?: boolean;
}

export function useBrokerCasesSearch(
  params: CaseSearchParams,
  options: UseBrokerCasesSearchOptions = {},
): UseQueryResult<CaseSearchResponse> {
  const { enabled = true } = options;

  return useQuery([BROKER_CASES_SEARCH_QUERY_KEY, params], () => brokerCasesApi.searchCases(params), {
    enabled,
    keepPreviousData: true,
  });
}
